'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["onInsert"];
import PropTypes from 'prop-types';
import MorphingLinkPopoverBody from './MorphingLinkPopoverBody';
import { PopoverType } from '../../constants/popover';
import { omit } from '../../utils/iterables';
import { jsx as _jsx } from "react/jsx-runtime";
const propTypes = Object.assign({
  onInsert: PropTypes.func.isRequired
}, omit(['onSubmit'], MorphingLinkPopoverBody.propTypes));
function InsertLinkPopoverBodyV2(props) {
  const {
      onInsert
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsx("div", {
    className: "small-popover-body p-all-5",
    children: /*#__PURE__*/_jsx(MorphingLinkPopoverBody, Object.assign({}, rest, {
      popoverType: PopoverType.INSERT,
      onSubmit: onInsert
    }))
  });
}
InsertLinkPopoverBodyV2.propTypes = propTypes;
InsertLinkPopoverBodyV2.displayName = 'InsertLinkPopoverBodyV2';
export default InsertLinkPopoverBodyV2;